import React from 'react';
import { Link } from 'react-router-dom';
import { ShopTypeLinksProps } from '../interfaces';
import { getProductTypeIcon } from '../../utils/productTypeIcons';
import './ShopTypeLinks.scss';

const ShopTypeLinks: React.FC<ShopTypeLinksProps> = ({
  types,
  shopGender,
  currentGender,
  currentType,
  isProductsPage,
}) => {
  const getCatalogPath = (type: string) => {
    const params = new URLSearchParams({ type });

    if (shopGender) {
      params.set('gender', shopGender);
    }

    return `/products?${params.toString()}`;
  };

  return (
    <>
      {types.map((type) => {
        const typePath = getCatalogPath(type.name);
        const isActiveType =
          isProductsPage &&
          currentType === type.name &&
          currentGender === shopGender;
        const imageUrl = getProductTypeIcon(type.name, type.image?.publicUrl);

        return (
          <Link
            key={typePath}
            to={typePath}
            className={`menu-type-item mobile-accordion__item ${
              isActiveType ? 'is-active-route' : ''
            }`}
          >
            <span className="menu-type-label">{type.name}</span>
            <span className="menu-type-icon-frame">
              {imageUrl ? (
                <img src={imageUrl} alt={type.name} className="menu-type-icon" />
              ) : (
                <span className="menu-type-icon-fallback" aria-hidden="true">
                  {type.name.charAt(0).toUpperCase()}
                </span>
              )}
            </span>
          </Link>
        );
      })}
    </>
  );
};

export default ShopTypeLinks;
